function parsePermissao(chave, descricao) {
  const partesChave = chave.split('.');
  const partesDescricao = (descricao || '').split('|');

  return {
    niveis: partesChave.map((parte, idx) => ({
      chave: parte,
      descricao: partesDescricao[idx] || formatarTitulo(parte),
      profundidade: idx,
    })),
    chave,
    descricao,
  };
}

function buildHierarchy(permissoes) {
  const hierarchy = {};

  permissoes.forEach((permissao) => {
    const { niveis, chave } = parsePermissao(permissao.chave, permissao.descricao);

    if (niveis.length < 2) return;

    const app = niveis[0].chave;
    const modulo = niveis[1].chave;

    if (!hierarchy[app]) {
      hierarchy[app] = {
        nome: app,
        nomeLegivel: niveis[0].descricao,
        modulos: {},
      };
    }

    if (!hierarchy[app].modulos[modulo]) {
      hierarchy[app].modulos[modulo] = {
        nome: modulo,
        nomeLegivel: niveis[1].descricao,
        telas: {},
      };
    }

    const telaChave = niveis[2] ? niveis[2].chave : 'root';
    const telaDescricao = niveis[2] ? niveis[2].descricao : 'Raiz';

    if (!hierarchy[app].modulos[modulo].telas[telaChave]) {
      hierarchy[app].modulos[modulo].telas[telaChave] = {
        nome: telaChave,
        nomeLegivel: telaDescricao,
        permissoes: [],
        grupos: {},
      };
    }

    if (niveis.length > 4) {
      const grupoChave = niveis.slice(3, -1).map((n) => n.chave).join('.');
      const grupoDescricao = niveis.slice(3, -1).map((n) => n.descricao).join(' > ');

      if (!hierarchy[app].modulos[modulo].telas[telaChave].grupos[grupoChave]) {
        hierarchy[app].modulos[modulo].telas[telaChave].grupos[grupoChave] = {
          caminho: grupoChave,
          descricao: grupoDescricao,
          niveis: niveis.slice(3, -1),
          permissoes: [],
        };
      }

      hierarchy[app].modulos[modulo].telas[telaChave].grupos[grupoChave].permissoes.push({
        ...permissao,
        niveis,
        acao: niveis[niveis.length - 1].descricao,
      });
    } else {
      hierarchy[app].modulos[modulo].telas[telaChave].permissoes.push({
        ...permissao,
        niveis,
        acao: niveis[niveis.length - 1].descricao,
      });
    }
  });

  return hierarchy;
}

function formatarTitulo(value) {
  return String(value || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase());
}

function permissoesHierarchy(permissoes) {
  const hierarchy = buildHierarchy(permissoes);

  return Object.entries(hierarchy).map(([appKey, app]) => ({
    app: appKey,
    nomeApp: app.nomeLegivel,
    modulos: Object.entries(app.modulos).map(([moduloKey, modulo]) => ({
      modulo: moduloKey,
      nomeModulo: modulo.nomeLegivel,
      telas: Object.entries(modulo.telas).map(([telaKey, tela]) => ({
        tela: telaKey,
        nomeTela: tela.nomeLegivel,
        permissoes: tela.permissoes.map((p) => ({
          chave: p.chave,
          niveis: p.niveis,
          acao: p.acao,
          descricao: p.descricao,
        })),
        grupos: Object.entries(tela.grupos).map(([grupoKey, grupo]) => ({
          caminho: grupoKey,
          descricao: grupo.descricao,
          niveis: grupo.niveis,
          permissoes: grupo.permissoes.map((p) => ({
            chave: p.chave,
            niveis: p.niveis,
            acao: p.acao,
            descricao: p.descricao,
          })),
        })),
      })),
    })),
  }));
}

export { permissoesHierarchy, buildHierarchy, parsePermissao, formatarTitulo };

